fx.ns("desktop.common.toolbar", class ToolBarScroller extends shared.stage.ToolBarAction{
    
    constructor(command, component, container)
    {
        super(command, component, container);
    }

    onReady()
    {
        super.onReady();

        this.scrollPosition = this.node.scrollLeft;

        this.on('mousewheel', this._mousewheel);
        this.on('click', this._click );
        this.on("touchmove", this._touchMove);
    }

    _touchMove(event)
    {
        event.preventDefault();
    }

    _mousewheel(event) {
        
        // TouchPad
        if (event.wheelDeltaY ? event.wheelDeltaY === -3 * event.deltaY : event.deltaMode === 0)
            return;
        
        let scrollDelta = (this.node.scrollWidth - this.node.clientWidth) * 0.1;
        if (event.deltaY < 0)
            this.scrollPosition += scrollDelta;
        else
            this.scrollPosition -= scrollDelta;

        this.scrollPosition = Math.max( Math.min(this.scrollPosition, this.node.scrollWidth - this.node.clientWidth), 0);
    

        fx.dom.stop( this.node, true, false);
        fx.dom.animate( this.node, {scrollLeft : this.scrollPosition}, 150, "easeOutQuad");

        
        event.preventDefault();
        event.stopImmediatePropagation();
    }

    resize(alone){
		if (!this._initialized) 
            return;

        let height = fx.dom.outerHeight(this.find(".item"));
        
        if (this.command.items.getItemAt(0).label)
            this._viewport.height = height + 40;
        else
            this._viewport.height = height + 20;

        super.resize(alone)
    }
           
    
    /*create()
    {
        super.create();
        this._node.innerHTML = this.render();
    }*/


    render()
    {
        let html = "";

        for (let i = 0; i < this.command.items.length; i++ ){
            
            html += '<div class="item ';
            
            let item = this.command.items.getItemAt(i);

            if ( this.component[this.command.field] == item.id)
                html += " selected";

            html += '" data="' + item.id + '">';
            
            if (item.thumb.indexOf("<svg") == 0)
                html += item.thumb;
            else
                html += '<img src="' + item.thumb + '">';
            
            if (item.label)
                html += '<div class="label">' + item.label + '</div>';

            html += '</div>';
        }
            
        return html;
    }

    _click(event)
    {
        let item = fx.dom.parent(event.target, ".item");

        if (item)
        {
            let id = item.getAttribute("data");
            let element = this.command.items.find({id : id});
            
            //this.trigger("selected", element);

            this.action( element );

            let selected = this.find(".selected");

            this.removeClass(selected, "selected" );
            this.addClass(item, "selected" );
        }
    }

});